import ModalTabs from '../../../baseComponents/ModalsLayouts/ModalTabs'
import { ModalEditComponentProps } from '../../../baseComponents/ModalsLayouts/types'
import { ComponentTabObject } from '../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import CheckReservedStockProductTab from './Tabs/CheckReservedStockProductTab'
import MainCheckStockProduct from './Tabs/MainCheckStockProduct'

interface ModalCheckProductStockProps extends ModalEditComponentProps { }

const ModalCheckProductStock: React.FC<ModalCheckProductStockProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const tabs: ComponentTabObject = {
        'main': { component: MainCheckStockProduct, text: t('stock', 'Stock') },
        'reserves': { component: CheckReservedStockProductTab, text: t('reserves', 'Reservas') }
    }
    return (
        <ModalTabs {...rest} tabs={tabs} tab={'main'} className='notFlexAutoFormRender' extraComponentData={{
            ...rest,
            unitMeasure: allRowData?.Product?.unitMeasure,
            productType: allRowData?.Product?.productType,
            isVariantProduct: allRowData?.Product?.isVariantProduct,
            controlUnitType: allRowData?.Product?.controlUnitType,
            StockParentId: parseInt(allRowData?.id),
            CurrencyId: allRowData?.CurrencyId || ''
        }} userPermissions={{ n: 1, permission: 'read' }} />
    )
}


export default ModalCheckProductStock